import { render, staticRenderFns } from "./PromotionsStrategyBrandAwareness.vue?vue&type=template&id=6cadfbf0&scoped=true&"
import script from "./PromotionsStrategyBrandAwareness.vue?vue&type=script&lang=ts&"
export * from "./PromotionsStrategyBrandAwareness.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionsStrategyBrandAwareness.vue?vue&type=style&index=0&id=6cadfbf0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cadfbf0",
  null
  
)

export default component.exports